<template>
    <div class="row" v-if="isLoading">
        <div class="col-12 min-height-500 text-center p-5 d-flex justify-content-center align-items-center">
            <div class="spinner-border m-5 p-3" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading',
    props: {
        isLoading: { required: true, type: Boolean },
    },
    data() {
        return {}
    },
}
</script>
